import {
  deleteElement,
  fetchElements,
  saveElementsType,
  updateElement,
} from "@/lib/utils";
import type {
  ProyectosPropios,
  ActuacionesPropias,
  TransaccionesPropias,
} from "@/types/models/propios";
import type { PropiosRepository } from "@/lib/repositories/interfaces/propios-repository.interface";

const PROYECTOS_PROPIOS_FIELDS = ["*", "translations.*"] as const;

const ACTUACIONES_PROPIAS_FIELDS = ["*", "translations.*"] as const;

const TRANSACCIONES_PROPIAS_FIELDS = ["*"] as const;

export const propiosRepository: PropiosRepository = {
  fetchProyectosPropiosByTenant: (
    tenantId: number
  ): Promise<ProyectosPropios[]> =>
    fetchElements<ProyectosPropios>(
      "proyectos_propios",
      [...PROYECTOS_PROPIOS_FIELDS],
      undefined,
      {
        tenant: { _eq: tenantId },
      }
    ),

  fetchActuacionesPropiasByTenant: (
    tenantId: number
  ): Promise<ActuacionesPropias[]> =>
    fetchElements<ActuacionesPropias>(
      "actuaciones_propias",
      [...ACTUACIONES_PROPIAS_FIELDS],
      undefined,
      {
        proyecto_propio: {
          tenant: { _eq: tenantId },
        },
      }
    ),

  fetchTransaccionesPropiasByTenant: (
    tenantId: number
  ): Promise<TransaccionesPropias[]> =>
    fetchElements<TransaccionesPropias>(
      "transacciones_propias",
      [...TRANSACCIONES_PROPIAS_FIELDS],
      undefined,
      {
        actuacion: {
          proyecto_propio: {
            tenant: { _eq: tenantId },
          },
        },
      }
    ),

  createProyectoPropio: async (
    payload: Partial<ProyectosPropios>
  ): Promise<ProyectosPropios> =>
    (await saveElementsType<ProyectosPropios>("proyectos_propios", [payload]))[0],

  updateProyectoPropio: (
    id: number,
    changes: Partial<ProyectosPropios>
  ) => updateElement("proyectos_propios", id, changes),

  deleteProyectoPropio: (id: number): Promise<void> =>
    deleteElement("proyectos_propios", id),

  createActuacionPropia: async (
    payload: Partial<ActuacionesPropias>
  ): Promise<ActuacionesPropias> =>
    (await saveElementsType<ActuacionesPropias>("actuaciones_propias", [
      payload,
    ]))[0],

  updateActuacionPropia: (
    id: number,
    changes: Partial<ActuacionesPropias>
  ) => updateElement("actuaciones_propias", id, changes),

  deleteActuacionPropia: (id: number): Promise<void> =>
    deleteElement("actuaciones_propias", id),

  createTransaccionPropia: async (
    payload: Partial<TransaccionesPropias>
  ): Promise<TransaccionesPropias> =>
    (await saveElementsType<TransaccionesPropias>("transacciones_propias", [
      payload,
    ]))[0],

  updateTransaccionPropia: (
    id: number,
    changes: Partial<TransaccionesPropias>
  ) => updateElement("transacciones_propias", id, changes),

  deleteTransaccionPropia: (id: number): Promise<void> =>
    deleteElement("transacciones_propias", id),
};
